<template>
  <!-- eslint-disable -->
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <div>
        <v-speed-dial
          v-model="fab"
          right
          top
          fixed
          direction="bottom"
          transition="slide-y-reverse-transition"
        >
          <template v-slot:activator>
            <v-btn class="refresh-btn" v-model="fab" color="blue darken-2" dark fab>
              <v-icon v-if="fab">close</v-icon>
              <v-icon v-else>ac_unit</v-icon>
            </v-btn>
          </template>
          <v-btn
            class="refresh-potential-calamities-btn"
            fab
            dark
            small
            color="red"
            @click="loadPotentialCalamities()"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-speed-dial>
        <h2>Potential Calamities</h2>
        <v-select
          label="Select"
          content-class="client-filter-list"
          class="client-filter-select"
          :items="potentialCalamities"
          @change="filterByClient"
          multiple
          item-text="Client"
          item-value="Client"
          :menu-props="{maxHeight:'400'}"
          hint="Filter Clients"
          persistent-hint
        ></v-select>
        <v-select
          label="Select"
          content-class="time-zone-filter-list"
          class="time-zone-filter-select"
          :items="potentialCalamities"
          @change="filterByTimeZone"
          multiple
          item-text="TimeZone"
          item-value="TimeZone"
          :menu-props="{maxHeight:'400'}"
          hint="Filter TimeZones"
          persistent-hint
        ></v-select>
        <v-data-table :mobile-breakpoint="0"
          class="potential-calamities-data-table no-wrap-th"
          disable-pagination hide-default-footer
          :items="filteredList"
          item-key="Id"
          :headers="headers"
          :sort-by.sync="sortBy" :sort-desc.sync="descending"
          :loading="loading"
        >
          <template v-slot:header.InTransitArrived="{ header }">
            {{header.text}} <span v-if="header.subText"><br/>{{ header.subText }}</span>
          </template>
          <template v-slot:header.InTransitDeparted="{ header }">
            {{header.text}} <span v-if="header.subText"><br/>{{ header.subText }}</span>
          </template>
          <template v-slot:header.AtDestinationMetro="{ header }">
            {{header.text}} <span v-if="header.subText"><br/>{{ header.subText }}</span>
          </template>
          <template
            v-slot:item="{ item }"
            item-key="HashKey"
          >
            <tr @click="navigateToDetail(item.HashKey)" class="potential-calamity">
              <td>
                {{item.Client}}
              </td>
              <td>
                {{ item.Location }}
              </td>
              <td>
                {{ item.CurrentCity }}
              </td>
              <td>
                {{ item.CurrentState }}
              </td>
              <td>
                {{ item.TimeZone }}
              </td>
              <td>
                {{ item.Exception }}
              </td>
              <td>
                {{ item.AtOrigin }}
              </td>
              <td>
                {{ item.InTransitArrived }}
              </td>
              <td>
                {{ item.InTransitDeparted }}
              </td>
              <td>
                {{ item.AtDestinationMetro }}
              </td>
              <td>
                {{ item.Count }}
              </td>
            </tr>
          </template>
          <template slot="no-data">

            <div
              v-if="loading"
              class="text-xs-center"
            >
              Loading potential calamities. . .
            </div>
            <div
              v-else
              class="text-xs-center"
            >
              No potential calamities
            </div>

          </template>
        </v-data-table>
      </div>
    </v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>

<script>
import { mapGetters } from "vuex";
import potentialCalamitiesReportModule, {
  POTENTIAL_CALAMITY_REPORT_NAMESPACE
} from "./store/potentialCalamityReportStore";
export default {
  name: "CalamitiesNew",
  data() {
    return {
      fab: false,
      descending: true,
      sortBy: "Count",
      headers: [
        {
          text: "Client",
          value: "Client",
          align: "left"
        },

        {
          text: "Location",
          value: "Location",
          align: "left"
        },
        {
          text: "Current City",
          value: "CurrentCity",
          align: "left"
        },
        {
          text: "Current State",
          value: "CurrentState",
          align: "left"
        },
        {
          text: "TimeZone",
          value: "TimeZone",
          align: "left"
        },
        {
          text: "Exception",
          value: "Exception",
          align: "left"
        },
        {
          text: "At Origin",
          value: "AtOrigin",
          align: "left"
        },
        {
          text: "In Transit",
          value: "InTransitArrived",
          align: "left",
          subText: "(Arrived)"
        },
        {
          text: "In Transit",
          value: "InTransitDeparted",
          align: "left",
          subText: "(Departed)"
        },
        {
          text: "At Destination Metro",
          value: "AtDestinationMetro",
          align: "left",
          subText: "(> 9:00 local)"
        },
        {
          text: "Total",
          value: "Count",
          align: "left"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(POTENTIAL_CALAMITY_REPORT_NAMESPACE, [
      "potentialCalamities",
      "filteredList",
      "loading"
    ])
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(
      POTENTIAL_CALAMITY_REPORT_NAMESPACE,
      potentialCalamitiesReportModule
    );
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.CALAMITY_ADMIN]).then(
      res => {
        if (res) {
          this.loadPotentialCalamities();
        } else this.$goHome();
      }
    );
  },
  methods: {
    filterByClient(val) {
      return this.$store.dispatch(
        `${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/FILTER_BY_CLIENT`,
        val
      );
    },
    filterByTimeZone(val) {
      return this.$store.dispatch(
        `${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/FILTER_BY_TIMEZONE`,
        val
      );
    },
    navigateToDetail(hashKey) {
      return this.$store
        .dispatch(`${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/SELECT_POTENTIAL`, {
          id: hashKey
        })
        .then(() => {
          this.$router.push({
            path: `/potential-calamities-report/${hashKey}`
          });
        });
    },
    loadPotentialCalamities() {
      return this.$store.dispatch(
        `${POTENTIAL_CALAMITY_REPORT_NAMESPACE}/LOAD_POTENTIAL`
      );
    }
  }
};
</script>
